module.exports = __webpack_public_path__ + "img/slider_3.cd0873a2.jpg";